<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small"  label-width="100px">
                    <el-form-item label="化学品名称"><el-input v-model="queryParams.title" placeholder="化学品名称"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd">新增</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable"
					tooltip-effect="dark" @selection-change="handleSelectionChange" @sort-change="sortChange" :default-sort="queryParams.defaultSort">
                    <el-table-column prop="title" label="化学品名称"></el-table-column>
                    <el-table-column prop="areaVariableTitle" label="截面积变量名"></el-table-column>
                    <el-table-column prop="proportionVariableTitle" label="比重变量名"></el-table-column>
                    <el-table-column prop="heightVariableTitle" label="高度变量名"></el-table-column>
                    <el-table-column prop="topHeightVariableTitle" label="量程上限变量名"></el-table-column>
                    <el-table-column prop="consumeFormula" label="消耗公式"></el-table-column>
					<el-table-column label="状态" width="80px">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)" ></el-switch>
						</template>
					</el-table-column>
                    <el-table-column prop="creatorName" label="创建人名称"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="150">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
							<el-button size="mini" type="danger"  @click="handleDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage" :page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
			<el-form :inline="true"  :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="160px">
                <el-form-item label="化学品名称" prop="title"><el-input type="text" v-model="addOrUpdateForm.title"></el-input></el-form-item>
                <el-form-item label="截面积变量名" prop="areaVariableTitle"><el-input type="text" v-model="addOrUpdateForm.areaVariableTitle"></el-input></el-form-item>
                <el-form-item label="比重变量名" prop="proportionVariableTitle"><el-input type="text" v-model="addOrUpdateForm.proportionVariableTitle"></el-input></el-form-item>
                <el-form-item label="高度变量名" prop="heightVariableTitle"><el-input type="text" v-model="addOrUpdateForm.heightVariableTitle"></el-input></el-form-item>
                <el-form-item label="量程上限变量名" prop="topHeightVariableTitle"><el-input type="text" v-model="addOrUpdateForm.topHeightVariableTitle"></el-input></el-form-item>
                <el-form-item label="消耗公式" prop="consumeFormula"><el-input type="text" v-model="addOrUpdateForm.consumeFormula"></el-input></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import BaseSearch from '@/components/layout/base/base-search-front';

export default {
	extends: BaseSearch,
	data() {
		return {
			url: 'chemicals/config',
			name: '化学品配置',
			rules: {
                title: [
                     { required: true, message: '请输入化学品名称', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
                areaVariableTitle: [
                     { required: true, message: '请输入液体截面积变量名', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
                proportionVariableTitle: [
                     { required: true, message: '请输入液体比重变量名', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
                heightVariableTitle: [
                     { required: true, message: '请输入液体高度变量名', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
                topHeightVariableTitle: [
                     { required: true, message: '请输入液位量程上限变量名', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
                consumeFormula: [
                     { required: true, message: '请输入消耗公式', trigger: 'blur' },
                     { max: 100, message: '长度最长支持100', trigger: 'blur' }
                 ],
			}
		};
	},
	filters:{
	},
	methods: {
		createUpdateForm(row) {
			if (row) {
				var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
				this.addOrUpdateForm = newObj;
			} else {
				this.addOrUpdateForm = {
				};
			}
		},
		beforeUpdate() {
		}
	},
	mounted: function() {
	}
};
</script>

<style scoped>
.el-dialog {
	width: 35% !important;
}
</style>




// WEBPACK FOOTER //
// src/view/system/chemicalsConfig.vue